import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  warningText: {
    textDecoration: 'underline',
  },
});
